import { AnyAction } from 'redux';
import { ProgressbarItemsEnum } from '../../app/progressbar/data/progressbarItems';

export const aktiveRubrikReducer = function (
  sectionState: ProgressbarItemsEnum = null,
  action: AnyAction,
): ProgressbarItemsEnum {
  switch (action.type) {
    default:
      return sectionState;
  }
};
